module.exports = __webpack_public_path__ + "img/6.a6a053f6.svg";